import { createSlice } from "@reduxjs/toolkit";
import { donatedNonprofitAPI, donateToAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
  donations:null
};

const donateToSlice = createSlice({
  name: "donateTo",
  initialState: data,
  reducers: {
    donateToSlice(state) {
      state.isLoading = true;
    },
    donateToSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    donatedNonprofitSliceSuccess(state, action) {
      state.isLoading = false;
      state.donations = action.payload;
      state.message = null;
    },
    donateToSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    donateToSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const donateToHandler = (order_id:string,donation_id?:string) => async (dispatch: any) => {
  try {
    dispatch(donateToAction.donateToSlice());
    const response: any = await donateToAPI(order_id,donation_id);
    dispatch(donateToAction.donateToSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(donateToAction.donateToSliceFailure(e?.response?.data?.message));
    dispatch(donateToAction.donateToSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export const donatedNonprofitsHandler = (payment_id:string) => async (dispatch: any) => {
  try {
    dispatch(donateToAction.donateToSlice());
    const response: any = await donatedNonprofitAPI(payment_id);
    dispatch(donateToAction.donatedNonprofitSliceSuccess(response));
    //showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(donateToAction.donateToSliceFailure(e?.response?.data?.message));
    dispatch(donateToAction.donateToSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default donateToSlice.reducer;
export const donateToAction = donateToSlice.actions;
